export function createInScopeTester<T>(
  selectionScope: Map<T, unknown> | Set<T> | T[]
) {
  const size =
    selectionScope instanceof Set
      ? selectionScope.size
      : selectionScope instanceof Map
        ? selectionScope.size
        : selectionScope.length;
  if (size === 0) {
    return () => true;
  }

  const scope =
    selectionScope instanceof Set
      ? selectionScope
      : selectionScope instanceof Map
        ? new Set<T>(selectionScope.keys())
        : new Set<T>(selectionScope);
  return (id: T) => scope.has(id);
}
